import PropTypes from "prop-types";
import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const InfoTooltip = ({ infoText }) => {
  return (
    <OverlayTrigger
      placement="right"
      overlay={
        <Tooltip id="tooltip" className="survey-tooltip">
          {infoText}
        </Tooltip>
      }
    >
      <FontAwesomeIcon icon={faInfoCircle} />
    </OverlayTrigger>
  );
};

InfoTooltip.propTypes = {
  infoText: PropTypes.string.isRequired
};

export default InfoTooltip;
